// extracted by mini-css-extract-plugin
export default {"mCard":"WA-z","image":"XA-z","imageNoBackground":"YA-z","imageHasCategory":"ZA-z","fullWidth":"_A-z"};